<template>
  <div id="stand-checkins-dialog" class="custom-modal">
    <div class="modal-body">
      <div class="checkins" v-if="getCheckinItems.length > 0">
        <div class="checkin" v-for="item in getCheckinItems" :key="item.id">
          <div class="participant-info">
            <ParticipantMini :data="prepareParticipantMini(item)" :type="1" />
          </div>
          <div style="width: 100%">
            <div class="checkin-item" v-for="checkin in item.standCheckIns" :key="checkin.id">
              <div class="cols">
                <div class="col">
                  <span class="col-title">{{ $t("options.stand") }}</span>
                  <span class="col-value" v-if="stands.some(k => k.id == checkin.standID)">{{ stands.find(k => k.id == checkin.standID).title }}</span>
                </div>
                <div class="col">
                  <span class="col-title">{{ $t("event.table.date") }}</span>
                  <span class="col-value">{{ $moment(checkin.checkInDate).format("LLL") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-expo-lottie'" :title="$t('event.buttons.checkinList')" @btnAdd="false" @btnRefresh="false" :buttonAdd="false" :buttonRefresh="false" :loading="loading" />
      </div>
    </div>

    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.stands.standCheckin.close") }}</el-button>
      </div>
      <div class="center-buttons" v-if="getCheckinItems.length > 0">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="$store.state.standcheckins.filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="$store.state.standcheckins.filter.total"></el-pagination>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="exportExcel">{{ $t("contentManagement.stands.standCheckin.download") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import SpeakerAddUpdate from "../../components/SpeakerAddUpdate";
import PaymentDetail from "../../components/PaymentDetail";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import ParticipantMini from "../../components/ParticipantMini";
import $ from "jquery";
export default {
  metaInfo: {
    title: "Stand Check-in"
  },
  components: {
    SpeakerAddUpdate,
    PaymentDetail,
    PageCountInfo,
    ParticipantMini
  },
  name: "StandCheckins",
  data() {
    return {
      loading: false,
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "speaker",
      widgetUrl: "https://cdn.holacon.com/widgets/event-speakers.html?applicationID=5e2b3b73286bd618b47d1e6e&amp;eventID=5e30227b83089521b86ef7bf",
      excelTemplateUrl: this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx",
      detailData: null,
      detailDialog: false,
      participantData: null,
      stands: []
    };
  },

  methods: {
    exportExcel() {
      console.log(this.$store.state.standcheckins.filter.standIDs[0]);
      if (this.$store.state.standcheckins.filter.standIDs[0] != null && this.$store.state.standcheckins.filter.standIDs[0] != undefined) {
        this.exportXlsx(10, this.$store.state.standcheckins.filter.standIDs[0]);
      } else {
        this.$message.error("Bir sorun oluştu");
      }
    },
    changePaymentStatus(payload) {
      this.$store.dispatch("changePaymentStatus", {
        ...payload,
        context: this
      });
    },
    prepareParticipantMini(row) {
      return {
        firstName: row.firstName,
        lastName: row.lastName,
        tagID: row.tagID,
        id: row.id
      };
    },
    // exportExcel() {
    //   this.$confirm(
    //     this.$t('message.export'),
    //     this.$t('message.warn'),
    //     {
    //       confirmButtonText: this.$t('event.variables.yes'),
    //       cancelButtonText: this.$t('event.variables.no'),
    //       type: "warning",
    //     }
    //   ).then(() => {
    //     axios.post("speaker/export", { id: null }).then((res) => {
    //       if (res.data.alert.hasError) {
    //         this.$message.error(res.data.alert.message);
    //       } else {
    //         this.$message.success(res.data.alert.message);
    //       }
    //     });
    //   });
    // },
    excelProgress(event) {
      this.excelPercent = event.percent;
    },
    itemUpdated(item) {
      var index = this.$store.state.standcheckins.items.findIndex(k => k.id == item.id);
      if (index != -1) {
        this.$store.state.standcheckins.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getStandCheckin");
    },
    handleSizeChange(take) {
      this.$store.commit("setStandCheckinTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setStandCheckinPage", page);
    },
    deleteItem(id) {
      this.$store.dispatch("deletePromotionHistory", { id, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch("togglePayment", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedPayments", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  mounted() {
    this.$store.dispatch("getPromotions");
    this.$store.dispatch("getStandCheckin");

    if (this.$store.state.standcheckins.filter.couponCode != null) {
      this.isFilterEnabled = true;
    }
  },
  created() {
    axios.post("stand/list", { take: 1000, skip: 0 }).then(res => {
      this.stands = res.data.data.items;
    });
  },
  computed: {
    getCheckinItems() {
      return this.$store.state.standcheckins.items;
    },
    skip() {
      return (this.$store.state.standcheckins.filter.page - 1) * this.$store.state.standcheckins.filter.take;
    },
    take() {
      return this.skip + this.$store.state.standcheckins.items.length;
    }
  },
  watch: {
    "$store.state.standcheckins.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getStandCheckin");
      }, 500);
    },
    "$store.state.standcheckins.filter.standIDs": function(val) {
      this.$store.dispatch("getStandCheckin");
    }
  }
};
</script>

<style>
.participant-info {
  width: 200px;
  padding-left: 20px;
}
.checkin {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.125);
}

.checkin-item {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 10px 15px;
  background: whitesmoke;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.125);
  border-left: 0.5px solid rgba(0, 0, 0, 0.125);
}

.checkin-item:last-child {
  border-bottom: 0px;
}

.checkin:first-child {
  border-top: 0.5px solid rgba(0, 0, 0, 0.125);
}

.cols {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  position: relative;
}

.cols .col {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.col-value p {
  margin: 0;
  color: silver;
}

.col-value span {
  color: #333;
}

.cols .col .col-title {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/StandCheckins.vue